import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class CuePoints {

  #rmp;
  #cuePointsInterval = null;
  #currentCuePointTime = -1;
  #currentCuePointText = '';

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get currentTime() {
    return this.#currentCuePointTime;
  }

  get currentText() {
    return this.#currentCuePointText;
  }

  destroy() {
    window.clearInterval(this.#cuePointsInterval);
  }

  init() {
    const duration = this.#rmp.duration;
    if (duration > -1 && this.#rmp.dom.timetotal && this.#rmp.dom.handle) {
      if (this.#rmp.cuePointsVisibleOnTimeline) {
        this.#rmp.cuePoints.forEach(cuePoint => {
          const cuePointElement = FW.createElement('div', 'rmp-cue-point');
          Logger.print('cue-point', 'adding following cue point:', cuePoint);
          if (typeof cuePoint.time === 'number') {
            const percentMarker = cuePoint.time * 100 / duration;
            if (percentMarker > 100 || percentMarker < 0) {
              return;
            }
            cuePointElement.style.left = percentMarker + '%';
            FW.insertBefore(this.#rmp.dom.timetotal, cuePointElement, this.#rmp.dom.handle);
            if (cuePoint.text) {
              const cuePointTextElement = FW.createElement('span', 'rmp-cue-point-text rmp-color-bg');
              FW.setText(cuePointTextElement, cuePoint.text);
              cuePointElement.appendChild(cuePointTextElement);
              cuePointElement.addEventListener('mouseenter', event => {
                if (event) {
                  event.stopPropagation();
                }
                cuePointTextElement.style.opacity = 1;
                cuePointTextElement.style.visibility = 'visible';
                FW.hide(this.#rmp.dom.indicator);
              });
              cuePointElement.addEventListener('mouseleave', event => {
                if (event) {
                  event.stopPropagation();
                }
                cuePointTextElement.style.opacity = 0;
                cuePointTextElement.style.visibility = 'hidden';
                FW.show(this.#rmp.dom.indicator);
              });
            }
          }
        });
      }
      let cuePointsEventCanFire = true;
      this.#cuePointsInterval = window.setInterval(() => {
        const isPaused = this.#rmp.paused;
        if (!isPaused) {
          const currentTime = this.#rmp.currentTime;
          for (let i = 0; i < this.#rmp.cuePoints.length; i++) {
            const cuePoint = this.#rmp.cuePoints[i];
            if (cuePoint.time && typeof cuePoint.time === 'number') {
              if ((Math.abs(currentTime - cuePoint.time) < 33) && cuePointsEventCanFire) {
                cuePointsEventCanFire = false;
                window.setTimeout(() => {
                  cuePointsEventCanFire = true;
                }, 33);
                this.#currentCuePointTime = cuePoint.time;
                this.#currentCuePointText = cuePoint.text;
                if (this.#rmp.cuePointsCallback !== null) {
                  this.#rmp.cuePointsCallback();
                }
                this.#rmp.dispatch('cuepoint');
                break;
              }
            }
          }
        }
      }, 33);
    }
  }

}
